<template>
  <figure class="swiper-container big_banner_wrap" v-if="swiperImgArray.length >= 1">
    <div class="swiper-wrapper">
      <div v-for="(item, index) in swiperImgArray" :key="index" class="swiper-slide">
        <img :src="item" alt="" width="750" height="464" />
      </div>
    </div>
    <div class="swiper-pagination paging"></div>
  </figure>
</template>

<script>

  import Swiper from 'swiper'
	import 'swiper/dist/css/swiper.css'


export default {
  name: 'swiper',
  // name: 'ScopeAdvertSwiper',
  props: {
    swiperImgArray: {
      type: Array,
      required: false
    },
    autoPlay: {
      type: Boolean,
      required: false
    },
    swiperWrapClass: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      swiperHeader: null
    };
  },
  updated() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      let that = this;
      if (this.swiperImgArray.length > 1) {
        this.$nextTick(function() {
          console.log('autoPlay=>', that.autoPlay);
          if (that.autoPlay) {
            that.swiperHeader = new Swiper('.big_banner_wrap', {
              loop: true,
              autoplay: {
                delay: 2000,
                disableOnInteraction: false
              },
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            });
          } else {
            that.swiperHeader = new Swiper('.big_banner_wrap', {
              loop: true,
              pagination: {
                el: '.swiper-pagination',
                clickable: true
              }
            });
          }
          console.log('swiperHeader->', that.swiperImgArray);
        });
      }
    }
  }
};
</script>

<style scoped lang="less">

	@import '../../style/variable.less';

  .big_banner_wrap{
    .banner_wrap(3.8rem);
    .border-B(2px);
		// .margin-Tb(10px);
  //   .shadow(10px;@shadowColor:rgba(0,0,0,.8););
  //   // .radius;
  }
  .dtail-page-swiper{
    .banner_wrap(6rem);
  }

	.detail_swiper{
		height: 5rem;
	}
  .paging {
  	bottom: .3rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/child-components/Swiper.vue